<side-panel-header [title]="'Customise dashboard' | translate" (closed)="close()" />

<h3 class="m-0 px-md pt-md text-base font-bold text-default">{{ 'Widgets' | translate }}</h3>

<div class="flex flex-col gap-sm p-md">
  @for (control of controlsOrder; track control) {
    @if (hrProWidgets.has(control)) {
      <sb-checkbox [formControl]="checkboxesFormGroup.controls[control]" [align]="'center'" [complexLabel]="true">
        <span class="truncate">{{ control | translate }}</span>
        <sb-badge [color]="hasHrPro() ? 'brandInverted' : 'grey'" size="xsmall" variant="pill">
          @if (!hasHrPro()) {
            <sb-icon name="lock-regular" />
          }
          {{ 'HR Pro' | translate }}
          @if (!hasHrPro()) {
            <span class="sr-only">{{ 'Locked' | translate }}</span>
          }
        </sb-badge>
      </sb-checkbox>
    } @else {
      <sb-checkbox [formControl]="checkboxesFormGroup.controls[control]">{{ control | translate }}</sb-checkbox>
    }
  }
</div>
